module.exports = __webpack_public_path__ + "img/order_material_to_excel_style1.b1bf494b.png";